import axios from '@/libs/api.request'
// 获取学生详细信息
export const getMenteeDetail = data => {
  return axios.request({
    url: '/mentee/detail',
    data,
    method: 'POST'
  })
}

// 查询教育背景
export const infoQueryEducational = data => {
  return axios.request({
    url: '/mentee/info/educational',
    data,
    method: 'POST'
  })
}

// 查询成绩信息
export const infoQueryScore = data => {
  return axios.request({
    url: '/mentee/info/score',
    data,
    method: 'POST'
  })
}

// 查询个人经验（补充信息）
export const infoQueryPersonalexp = data => {
  return axios.request({
    url: '/mentee/info/personalexp',
    data,
    method: 'POST'
  })
}

// 查询申请意向
export const infoQueryApplypurpose = data => {
  return axios.request({
    url: '/mentee/info/applypurpose',
    data,
    method: 'POST'
  })
}

// 查询项目信息
export const infoQueryItem = data => {
  return axios.request({
    url: '/mentee/info/item',
    data,
    method: 'POST'
  })
}

// 查询研究方向
export const infoQueryDirection = data => {
  return axios.request({
    url: '/mentee/info/direction',
    data,
    method: 'POST'
  })
}

// 查询科研经历
export const infoQueryScientific = data => {
  return axios.request({
    url: '/mentee/info/scientific',
    data,
    method: 'POST'
  })
}

// 查询实习经历
export const infoQueryInternship = data => {
  return axios.request({
    url: '/mentee/info/internship',
    data,
    method: 'POST'
  })
}

// 查询课外活动
export const infoQueryActivities = data => {
  return axios.request({
    url: '/mentee/info/activities',
    data,
    method: 'POST'
  })
}

// 查询家庭信息
export const infoQueryFamily = data => {
  return axios.request({
    url: '/mentee/info/family',
    data,
    method: 'POST'
  })
}
